import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { ProjectUserModel, UserService } from '../../services/user.service';

@Component({
  selector: 'app-project-users-modal',
  imports: [CommonModule, TableModule, TagModule, InputTextModule, FormsModule],
  templateUrl: './project-users-modal.html',
  styleUrls: ['./project-users-modal.css']
})
export class ProjectUsersModalComponent implements OnInit {
  projectUserList: ProjectUserModel[] = [];
  loading: boolean = false;
  searchValue: string = '';
  projectId: number = 0;

  constructor(
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private config: DynamicDialogConfig,
    private ref: DynamicDialogRef
  ) {
    this.projectId = this.config.data?.projectId || 0;
  }

  ngOnInit(): void {
    if (this.projectId > 0) {
      this.loadUsers();
    }
  }

  loadUsers(): void {
    this.loading = true;
    this.userService.getProjectUserList(this.projectId).subscribe({
      next: (data) => {
        this.projectUserList = data;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error('Error loading project users:', error);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  getUserStatusSeverity(isActive: boolean): string {
    return isActive ? 'success' : 'danger';
  }

  clear(table: any): void {
    table.clear();
    this.searchValue = '';
  }
}
